module.exports = __webpack_public_path__ + "images/banner-53d8522e845ada7f85c7f06ce85b7040.jpg";